import React, { useEffect, useState } from "react";
import axios from "axios";
import occupationList from "./occupations.json";
import { API_ENDPOINTS } from './apiConfig';
import { useNavigate } from 'react-router-dom';

import './Search.css';

const BASE_IMG_URL = API_ENDPOINTS.BASEIMGURL;
const API_URL = API_ENDPOINTS;

const ProfileDetailsPopup = ({ id, token, onClose }) => {
  const [data, setData] = useState(null);
  const [images, setImages] = useState([]);
  const [viewerIndex, setViewerIndex] = useState(null);
  const [touchStartX, setTouchStartX] = useState(0);

   const navigate = useNavigate();

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const res = await axios.post(`${API_URL.GETDETAILSBYID}`, { id }, { headers: { token } });
        if (res.data.result === 1) {
          setData(res.data.data);
          setImages(res.data.img);
        }
      } catch (err) {
        console.error("Failed to load profile", err);
      }
    };
      if (!token || token.trim() === '') {
             navigate('/login');
          }
    fetchDetails();
  }, [id, token]);

  const convertHeight = (cm) => `${Math.floor(cm / 30.48)}'${Math.round((cm % 30.48) / 2.54)}"`;

  if (!data) return null;

  return (
    <div className="position-fixed top-0 start-0 w-100 h-100 bg-white overflow-auto" style={{ zIndex: 2000, background: 'linear-gradient(135deg, #ffe0f0, #d0e8ff)' }}>
      <div className="d-flex justify-content-end p-3">
        <button className="btn-close" onClick={onClose}></button>
      </div>

      <div className="text-center px-3">
        {images.length > 0 && (
          <div className="position-relative">
            <img
              src={BASE_IMG_URL + images[0].Path}
              className="rounded mb-2 shadow"
              style={{ width: "100%", maxHeight: 300, objectFit: "cover", cursor: "pointer" }}
              onClick={() => setViewerIndex(0)}
              alt="Profile"
            />
            <div className="position-absolute top-0 end-0 m-2 badge bg-dark">
              {images.length} Images
            </div>
          </div>
        )}

        <div className="p-1" style={{ fontSize: '0.95rem' }}>
          <h6 className="fw-bold mb-2"><span style={{ color: '#ff69b4' }}>{data.name} </span>, <span className="text-muted fw-normal">Age {data.age}</span></h6>

          <ul className="list-unstyled mb-2">
            <li className="mb-1">
              <i className="bi bi-rulers me-2 text-primary"></i>
              Height: <strong>{convertHeight(data.height)}</strong>
            </li>

            <li className="mb-1">
              <i className="bi bi-person-gear me-2 text-info"></i>
              Occupation: <strong>{
                data.occupationID ? (occupationList.find(r => r.id === data.occupationID)?.name || data.occupation) : data.occupation
              }</strong>
            </li>

            <li className="mb-1">
              <i className="bi bi-heart-pulse-fill me-2 text-danger"></i>
              Marital Status: <strong>{
                data.mstatusID === 0 ? 'Unmarried' :
                data.mstatusID === 1 ? 'Divorced' :
                data.mstatusID === 2 ? 'Widow' :
                data.mstatusID === 3 ? 'Married' : ''
              }</strong>
            </li>

           
          </ul>

          <p className="mt-2 text-muted">
            <i className="bi bi-chat-right-text-fill me-2"></i>
            <em>{data.about}</em>
          </p>
        </div>
      </div>

    

{viewerIndex !== null && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-90 d-flex flex-column justify-content-center align-items-center"
    style={{ zIndex: 3000 }}
    onTouchStart={(e) => setTouchStartX(e.changedTouches[0].clientX)}
    onTouchEnd={(e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;

    if (diff > 50) {
        // Swipe Left → Next
        setViewerIndex((i) => (i + 1) % images.length);
    } else if (diff < -50) {
        // Swipe Right → Prev (wrap around)
        setViewerIndex((i) => (i - 1 + images.length) % images.length);
    }
    }}
  >
    <button className="btn-close btn-close-white position-absolute top-0 end-0 m-3" onClick={() => setViewerIndex(null)}></button>
    
    <img
      src={BASE_IMG_URL + images[viewerIndex].Path}
      alt="Full View"
      style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
    />
    
    <div className="text-white mt-3">
      {viewerIndex + 1} / {images.length}
    </div>
    
    <div className="d-flex gap-3 mt-2">
        <button
        className="btn d-flex align-items-center gap-1 rounded-pill shadow-sm"
        style={{ backgroundColor: '#ff69b4', color: 'white' }}
        onClick={() => setViewerIndex(i => (i - 1 + images.length) % images.length)}
        >
        <i className="bi bi-chevron-left"></i> Prev
        </button>

        <button
        className="btn d-flex align-items-center gap-1 rounded-pill shadow-sm"
        style={{ backgroundColor: '#ff69b4', color: 'white' }}
        onClick={() => setViewerIndex(i => (i + 1) % images.length)}
        >
        Next <i className="bi bi-chevron-right"></i>
        </button>
    </div>
  </div>
)}


    </div>
  );
};

export default ProfileDetailsPopup;
